import { type FigureInfoOverlapGroupFilter } from '../figureInfo'
import { stackHTables, stackVTables, type TextTable } from '../textTable'

/**
 * FigureInfoOverlapGroupFilter の配列を TextTable に変換します。
 *
 * @param overlapGroupFilters - 変換する FigureInfoOverlapGroupFilter の配列。
 * @returns 変換された TextTable。
 */
export function toOverlapGroupFiltersTextTable(
  overlapGroupFilters: FigureInfoOverlapGroupFilter[],
): TextTable {
  return 0 < overlapGroupFilters.length
    ? stackVTables(
        [
          [
            '',
            overlapGroupFilters[0]?.brand1,
            'x',
            overlapGroupFilters[0]?.brand2,
          ],
        ],
        ...overlapGroupFilters.map(({ combinations, name }) =>
          stackHTables(
            [[name]],
            combinations.map(({ brand1, brand2 }) => [brand1, 'x', brand2]),
          ),
        ),
      )
    : []
}
